import { AxiosResponse } from "axios";
import { getAxiosInstance, requestConfig } from "../../http-common";
import { CreateRoleRequest } from "../../models/ExcelAddin/CreateRoleRequest";
import { UpdateRoleRequest } from "../../models/ExcelAddin/UpdateRoleRequest";

const RESOURCE_NAME = "ExcelAddinRoles";

const getAll = () : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const update = (id: number,data: UpdateRoleRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${id}`, data, requestConfig());
}

const create = (data: CreateRoleRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, data, requestConfig());
}

const remove = (id: number) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
}

const RolesService = {
    getAll,
    update,
    create,
    remove
}

export default RolesService;